// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BOSHomeButton-module_link_DeQj9 * {
  background-color: var(--uu-utah-red);
}

.BOSHomeButton-module_link_DeQj9 {
  height: 100%;
}

.BOSHomeButton-module_link_DeQj9,
.BOSHomeButton-module_link_DeQj9:hover {
  text-decoration: none;
}

.BOSHomeButton-module_link_DeQj9:hover * {
  background-color: var(--uu-utah-red-hover);
}

.BOSHomeButton-module_icon_container_minimal_Wf1jP {
  max-height: 100%;
  min-height: 10px;
  background-color: var(--uu-utah-red);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.BOSHomeButton-module_icon_container_G_0_6 {
  padding: 24px;
}

.BOSHomeButton-module_icon_container_G_0_6 * {
  white-space: nowrap;
}

.BOSHomeButton-module_site_icon_A3Q5X {
  color: white !important;
}

.BOSHomeButton-module_site_title_common_dfEmH {
  color: white !important;
  font-family: Factoria, serif;
  font-weight: bold;
}

.BOSHomeButton-module_site_title_grDKa {
  margin: 4px 0 0 4px;
  font-size: 32px;
}

.BOSHomeButton-module_site_title_large_j_Y71 {
  margin: 8px 0 0 8px;
  font-size: 60px;
}
`, "",{"version":3,"sources":["webpack://./src/client/components/Generic/Navigation/BOSHomeButton.module.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;AACA;EAEE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EAEE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EAEE,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":[".link * {\n  background-color: var(--uu-utah-red);\n}\n\n.link {\n  height: 100%;\n}\n\n.link,\n.link:hover {\n  text-decoration: none;\n}\n\n.link:hover * {\n  background-color: var(--uu-utah-red-hover);\n}\n\n.icon_container_minimal {\n  max-height: 100%;\n  min-height: 10px;\n  background-color: var(--uu-utah-red);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n.icon_container {\n  composes: icon_container_minimal;\n  padding: 24px;\n}\n\n.icon_container * {\n  white-space: nowrap;\n}\n\n.site_icon {\n  color: white !important;\n}\n\n.site_title_common {\n  color: white !important;\n  font-family: Factoria, serif;\n  font-weight: bold;\n}\n\n.site_title {\n  composes: site_title_common;\n  margin: 4px 0 0 4px;\n  font-size: 32px;\n}\n\n.site_title_large {\n  composes: site_title_common;\n  margin: 8px 0 0 8px;\n  font-size: 60px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": `BOSHomeButton-module_link_DeQj9`,
	"icon_container_minimal": `BOSHomeButton-module_icon_container_minimal_Wf1jP`,
	"icon_container": `BOSHomeButton-module_icon_container_G_0_6 BOSHomeButton-module_icon_container_minimal_Wf1jP`,
	"site_icon": `BOSHomeButton-module_site_icon_A3Q5X`,
	"site_title_common": `BOSHomeButton-module_site_title_common_dfEmH`,
	"site_title": `BOSHomeButton-module_site_title_grDKa BOSHomeButton-module_site_title_common_dfEmH`,
	"site_title_large": `BOSHomeButton-module_site_title_large_j_Y71 BOSHomeButton-module_site_title_common_dfEmH`
};
export default ___CSS_LOADER_EXPORT___;
